import React from 'react';
import styles from './style.module.scss';

function GeneratedSign({signedImages}) {
  return (
   <div className={styles.selectSign}> 
      <div className={styles.selectSignatureInner}>
        {signedImages?.signedName && <img src={signedImages?.signedName} />}
        {signedImages?.signedInitials && <img src={signedImages?.signedInitials} />}
      </div>
   </div>
  )
}

export default GeneratedSign;